module.exports = __webpack_public_path__ + "media/images/pc/specials/common/frequent/flow_01-008a3efb7c5cd10f90bccb4fa9aecdb5.jpg";